/* eslint-disable no-undef */
/*
 * @Author: snail
 * @Date: 2020-03-25 16:47:18
 * @Last Modified by: snail
 * @Last Modified time: 2020-05-28 09:52:20
 * 美食岛App相关api
 */

import fetchHelper from '../fetch-helper';
import config from '../../config';
import { thirdPlatformLoginSource } from '../const';
import aesHelper from '../secure/aes/aesHelper';

// const showAlert = process.env.BUILD_ENV !== 'prod' || process.env.BUILD_ENV !== 'prodexp' || process.env.BUILD_ENV !== 'sgprod';

const getScriptPath = () => ((document.currentScript ? document.currentScript.src : '') || './').replace(/[^\/]*\.js$/, '');

const I_PARK_JS_BRIDGE_ID = 'iParkJSBridgeScript';
const I_PARK_JS_BRIDGE_PATH = `${getScriptPath()}iParkJSBridge.js`;

const REFUND_ORDER_NOTIFY_URL = `${process.env.STORE_HOST}/v1/msd/upPlus/orderStatusNotify`;

const iParkJsMethod = {
  closePage: { isSupportParams: false, isSupportCallBack: false },
  reloadPage: { isSupportParams: false, isSupportCallBack: false },
  setActionBarStyle: { isSupportParams: true, isSupportCallBack: false },
  getLoginUserInfo: { isSupportParams: true, isSupportCallBack: true },
  placeOrder: { isSupportParams: true, isSupportCallBack: true },
  queryOrder: { isSupportParams: true, isSupportCallBack: true },
  refundOrder: { isSupportParams: true, isSupportCallBack: true },
};

const getCallBackFun = (method, params, resolve, reject) => {
  const isSuccess = result => {
    const { errorCode = '', data = {} } = result || {};
    // if (showAlert) {
    //   alert(`回调成功与否拦截器，method：${method};params:${params};errorCode:${errorCode}`);
    // }
    if (method === 'placeOrder') {
      const { status } = data;
      return errorCode === 200 && status === 'TRADE_SUCCESS';
    }
    return errorCode === 200;
  };

  const isWillDeal = result => {
    const { errorCode = '', data = {} } = result || {};
    if (method === 'placeOrder') {
      const { status } = data;
      if (errorCode === 200 && (status === 'NEW_ORDER' || status === 'WAIT_BUYER_PAY' || status === 'UNKNOWN')) return false;
    }
    return true;
  };

  return result => {
    const _result = typeof result === 'string' ? JSON.parse(result || '') : result;
    const { errorCode = '', msg = '未知异常', data = {} } = _result || {};
    if (!isWillDeal(_result)) return;
    if (isSuccess(_result)) {
      resolve(data);
    } else {
      // if (showAlert) {
      //   alert(_result.toString());
      // }
      reject(new Error(`[${errorCode}]:${msg}`));
    }
  };
};

const iParkPlugin = {
  init() {
    return new Promise((resolve, reject) => {
      if (!!document.querySelector(`#${I_PARK_JS_BRIDGE_ID}`)) resolve();

      let dom = document.createElement('script');
      dom.id = I_PARK_JS_BRIDGE_ID;
      dom.src = I_PARK_JS_BRIDGE_PATH;
      dom.async = true;
      dom.defer = true;

      document.body.appendChild(dom);

      dom.addEventListener('load', () => {
        dom = null;
        resolve();
      });

      dom.addEventListener('error', () => {
        reject(new Error('加载iParkJSBridge失败'));
      });
    });
  },
  getMethodInfo(method) {
    if (!iParkJsMethod.hasOwnProperty(method)) throw new Error('iParkJSBridge不支持该方法');
    return iParkJsMethod[method];
  },

  _call(method, params) {
    return new Promise((resolve, reject) => {
      try {
        const { isSupportParams, isSupportCallBack } = iParkPlugin.getMethodInfo(method);
        const envErrorMsg = '环境异常(请在美食岛APP中使用)';
        window.iParkCallback = isSupportCallBack ? getCallBackFun(method, params, resolve, reject) : null;
        const _param = isSupportCallBack && !params ? {} : params;
        if (!isSupportParams && !isSupportCallBack) {
          const res = iParkJSBridge.call(method);
          if (res === false) reject(envErrorMsg);
          resolve();
        } else if (!isSupportParams && !!isSupportCallBack) {
          const res = iParkJSBridge.call(method, _param, window.iParkCallback);
          if (res === false) reject(envErrorMsg);
        } else if (!!isSupportParams && !isSupportCallBack) {
          const res = iParkJSBridge.call(method, _param);
          if (res === false) reject(envErrorMsg);
          resolve();
        } else if (!!isSupportParams && !!isSupportCallBack) {
          const res = iParkJSBridge.call(method, _param, window.iParkCallback);
          if (res === false) reject(envErrorMsg);
        }
      } catch (ex) {
        reject(ex);
      }
    });
  },
  call(method, params) {
    return iParkPlugin.init().then(data => iParkPlugin._call(method, params));
  },
};

const iParkHelper = {
  /**
   * 获取iPark用户信息
   * {
   * userId	String	用户Id
   * mobilePhone	String	手机号码
   * nickName	String	昵称
   * headPhoto	String	用户头像地址
   * }
   * @returns Promise
   */
  getUserInfo() {
    if (process.env.NODE_ENV === 'development') {
      return Promise.resolve({ mobilePhone: 13699477230, userId: '1231232', nickName: '小鸟', headPhoto: 'd' });
    }
    return iParkPlugin.call('getLoginUserInfo', { needMobilePhone: true });
  },
  /**
   * 判断是否是美食岛App环境
   * @param {*} path
   */
  isIParkEvn(path = '') {
    let _path = path;
    if (!_path) {
      _path = location.search || '';
    }
    const res = _path.match(/accessFrom=(.*?)(&|$)/);

    const accessFrom = window.sessionStorage ? window.sessionStorage.getItem('ACCESS_FROM') : '';
    if ((res && Array.isArray(res) && res[1] === 'iParkApp') || accessFrom === 'iParkApp') {
      window.sessionStorage.setItem('ACCESS_FROM', 'iParkApp');
      return !0;
    }
    return !1;
  },

  /**
   * 登录
   */
  iParkLogin(info) {
    aesHelper.encrypt(info.mobile).then(mobilePhoneCiphertext => {
      const param = {
        ...info,
        ...{
          source: thirdPlatformLoginSource.I_PARK_LOGIN_SOURCE,
          fromBrand: 1, // 默认是从品牌首页登录
        },
        mobile: mobilePhoneCiphertext,
      };
      return fetchHelper.get(config.thirdPlatformLogin, param);
    });
  },

  /**
   * 获取ipark秘钥信息
   */
  getIParkSecret() {
    return fetchHelper.get(config.getIParkSecretAPI).then(data => {
      const { secret = '' } = data || {};
      return aesHelper.decrypt(secret);
    });
  },

  /**
   * 订单退款
   * @param {*} param
   */
  refundOrder(param) {
    let userInfo = {};
    let secret = '';
    const promise = iParkHelper
      .getUserInfo()
      .then(user => (userInfo = user))
      .catch(ex => {
        throw new Error('iPark获取用户信息失败');
      });
    const promiseSecret = iParkHelper.getIParkSecret().then(res => {
      secret = res;
    });
    return Promise.all([promise, promiseSecret])
      .then(data => {
        const { userId, mobilePhone } = userInfo;
        const key = `iPark_${userId}_${mobilePhone}_${secret}`;
        const { productId } = param;
        return iParkPlugin.call('refundOrder', Object.assign({}, param, { key, notifyUrl: `${REFUND_ORDER_NOTIFY_URL}?productId=${productId}` }));
      })
      .then(data => {
        const { type } = data;
        if (type === 1) {
          throw new Error('订单不存在！请联系商家处理');
        }
        return data;
      });
  },

  /**
   * 唤起支付插件
   * @param param {
   * amount:number  订单金额,单位【分】；注意⚠️！！！一定要以【分】为单位传入，且不允许有小数！比如10.1元，那么就是 10.1*100=1010
   * productId:string  商品号id
   * productType:String 下单商品类型: 1会议订单支付、2临时停车缴费、3月卡充值、4美食岛下单
   * key:String 支付key，格式（iPark_用户ID_手机号_secret）组建的字符串 ,secret另行提供（secret属于唯一鉴别调用方的私钥，请务必妥善保管）
   * }
   *
   * @return result {
   *    merOrderId  下单成功后的单号
   *    status  下单支付结果，具体查看：下单结果状态说明
   * }
   *
   * 取值	说明
   * NEW_ORDER	新订单
   * UNKNOWN	不明确的交易状态
   * TRADE_CLOSED	在指定时间段内未支付时关闭的交易;在交易完成全额退款成功时关闭的交易;支付失败的交易。 TRADE_CLOSED的交易不允许进行任何操作。
   * WAIT_BUYER_PAY	交易创建，等待买家付款
   * TRADE_SUCCESS	支付成功
   * TRADE_REFUND	订单转入退货流程，退货可能是部分也可能是全部。
   */
  invokePayPlugin(param) {
    let userInfo = {};
    let secret = '';
    const promise = iParkHelper
      .getUserInfo()
      .then(user => (userInfo = user))
      .catch(ex => {
        throw new Error('iPark获取用户信息失败');
      });
    const promiseSecret = iParkHelper.getIParkSecret().then(res => {
      secret = res;
    });

    return Promise.all([promise, promiseSecret])
      .then(() => {
        const { userId = '', mobilePhone = '' } = userInfo;
        const newParam = {
          ...param,
          key: `iPark_${userId}_${mobilePhone}_${secret}`,
          notifyUrl: `${REFUND_ORDER_NOTIFY_URL}`,
        };
        return iParkPlugin.call('placeOrder', newParam);
      })
      .catch(ex => {
        throw ex;
      });
  },
};

export default iParkHelper;



// WEBPACK FOOTER //
// ./src/helper/iPark/iParkHelper.js